/** The three stats every hero has and every contract pays for. */
export const STATS = ["Might", "Lore", "Guile"] as const;
export const STAT_ICONS = ["⚔", "✦", "❧"] as const;
export type StatTriple = [number, number, number];

/** One member of the guild's fixed cast (rows of the payoff matrix). */
export interface Hero {
  name: string;
  emoji: string;
  /** [might, lore, guile], each 1..9 — printed on the hero's card. */
  stats: StatTriple;
}

/** One posted contract (columns of the payoff matrix). */
export interface Quest {
  name: string;
  emoji: string;
  /** Flat purse paid no matter who takes the contract. */
  base: number;
  /** Gold paid per point of [might, lore, guile] — the demand profile. */
  weights: StatTriple;
}

/**
 * Static definition of one day (level). The first `heroCount` heroes of the
 * cast sit on the bench; `quests` always has exactly `heroCount` contracts.
 * `opt` is the **proven** maximum total gold of any roster — established by
 * the Hungarian method, confirmed by exhaustive search over all n! rosters
 * and a real HiGHS MILP in `levels.test.ts`, and re-proven live in the
 * browser at reveal time. `greedy` is the deterministic best-pair-first
 * baseline (the obvious play), the 2-star threshold.
 */
export interface Level {
  name: string;
  heroCount: number;
  quests: Quest[];
  opt: number;
  greedy: number;
}

/** The player's best completed roster for one day (for the reveal). */
export interface LevelRecord {
  /** assign[heroIdx] = questIdx (a permutation). Empty = never completed. */
  assign: number[];
  /** Total gold of that roster (0 when never completed). */
  total: number;
}

export type Phase = "intro" | "play" | "done";
